import api from './api';

export const getTokenUsageStats = async (days = 7) => {
  const response = await api.get('/stats/tokens/usage', { params: { days } });
  return response.data;
};

export const getProxyUsageStats = async (days = 7) => {
  const response = await api.get('/stats/proxies/usage', { params: { days } });
  return response.data;
};

export const getChannelActivityStats = async (days = 30, limit = 10) => {
  const response = await api.get('/stats/channels/activity', { params: { days, limit } });
  return response.data;
};

export const getQueueStatusStats = async () => {
  const response = await api.get('/stats/queue/status');
  return response.data;
};

export const getDashboardStats = async () => {
  const response = await api.get('/stats/dashboard');
  return response.data;
};
export const getReactionLogs = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const response = await fetch(`/api/stats/reaction-logs?${queryParams}`);
  if (!response.ok) {
    throw new Error('Failed to fetch reaction logs');
  }
  return response.json();
};